import React from "react";
import styled from "styled-components";

export const PageLoader = styled.div`
  position: absolute;
  z-index: 20000;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background-color: white;
`;

const Wrapper = styled.div`
  & {
    display: inline-block;
    position: relative;
    width: 80px;
    height: 80px;
  }
  & div {
    box-sizing: border-box;
    display: block;
    position: absolute;
    width: 64px;
    height: 64px;
    margin: 8px;
    border: 4px solid #4885ed;
    border-radius: 50%;
    animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
    border-color: #4885ed transparent transparent transparent;
  }
  & div:nth-child(1) {
    animation-delay: -0.45s;
  }
  & div:nth-child(2) {
    animation-delay: -0.3s;
  }
  & div:nth-child(3) {
    animation-delay: -0.15s;
  }
  @keyframes lds-ring {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

const Loader = ({ height, isVisible }) => {
  if (!isVisible) {
    return null
  }
  return (
    <div
      data-testid="spin-loader"
      style={{
        overflow: 'hidden',
        minHeight: height || "100%",
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Wrapper>
        <div />
        <div />
        <div />
        <div />
      </Wrapper>
    </div>
  )
};

export default Loader;
